<template>
  <el-form ref="form" :model="formData" :inline="inline" @submit.native.prevent>
    <el-form-item
      v-for="(item, index) in list"
      :key="index"
      :label="item.label"
      :prop="item.prop"
      class="mr15"
    >
      <template v-if="item.type === 'input'">
        <el-input v-model.trim="formData[item.prop]" :style="item.style" :placeholder="item.placeholder || '请输入'" clearable/>
      </template>

      <template v-if="item.type === 'btn'">
        <el-button
          :type="item.btnType"
          :icon="item.icon"
          @click="() => onSubmit({ cb: item.callback, isReset: item.isReset })"
          :style="item.style"
          >{{ item.text }}</el-button
        >
      </template>

      <template v-if="item.type === 'date-picker'">
        <el-date-picker
          :placeholder="item.placeholder || '请选择时间'"
          :start-placeholder="item.startPlaceholder||'开始时间'"
          :end-placeholder="item.endPlaceholde||'结束时间'"
          align="center"
          v-model="formData[item.prop]"
          :type="item.dateType"
          :style="item.style"
          value-format="yyyy-MM-dd"
          :picker-options="item.pickerOptions"
        ></el-date-picker>
      </template>

      <template v-if="item.type === 'select'">
        <el-select
          ref="select"
          v-model="formData[item.prop]"
          :placeholder="item.placeholder"
          :style="item.style"
          :disabled="item.disabled"
          @change="() => onChange({cb: item.callback})"
          @visible-change="visibleChange"
          clearable
        >
          <el-option :label="menue[item.labelKey || 'label']" v-for="(menue, i) in item.options" :value="menue[item.valueKey || 'value']" :key="i" />
        </el-select>
      </template>

      <template v-if="item.type === 'cascader'">
        <el-cascader
          :style="item.style"
          v-model="formData[item.prop]"
          :options="item.options"
          :props="item.params">
        </el-cascader>
      </template>
    </el-form-item>
  </el-form>
</template>

<script>
/***
 * inline:行排列 form属性
 * list: Array 组件列表，表单元素属性：
 *    type: string 组件类型
 *    prop: string form绑定的prop
 *    label: string 每项的label文字
 *    value:默认的值
 *    btnType: string 同button的type属性
 *    iocn:string btn的icon类型
 *    callback:fun 函数
 *    options: array 选项数据
 *      - valueKey  option的value取值别名
 *      - labelKey  option的label取值别名
 *    style: string 自定义样式
 */
export default {
  props: {
    list: Array,
    inline: {
      type: Boolean,
      default: function () {
        return true
      }
    }
  },
  data () {
    return {
      formData: {}
    }
  },
  created () {
    this.getformData()
  },
  mounted () {
    document.addEventListener('keyup', this.keyup)
  },
  destroyed () {
    document.removeEventListener('keyup', this.keyup)
  },
  methods: {
    keyup (event) {
      const code = event['keyCode']
      const isShowDialog = JSON.parse(sessionStorage.getItem('isShowDialog'))
      const item = this.list.find(item => item.type === 'btn' && !item.isReset)
      if (code === 13 && event.target.parentNode.className !== 'el-input el-pagination__editor is-in-pagination' && !isShowDialog) {
        this.onSubmit({ cb: item.callback })
      }
    },
    getformData () {
      let formObj = {}
      if (Array.isArray(this.list)) {
        this.list.forEach((item) => {
          if ('prop' in item) formObj[item.prop] = item.value || ''
        })
      }
      this.formData = formObj
    },
    onSubmit ({ cb, isReset }) {
      isReset && this.$refs.form.resetFields()
      cb({ ...this.formData })
    },
    visibleChange (flag) {
      if (!flag) {
        this.$refs.select.forEach(item => {
          item.blur()
        })
      }
    },
    onChange ({cb, info}) {
      if (!cb) return
      cb({ ...this.formData })
      this.list.forEach(item => {
        if (item.disabled) this.formData[item.prop] = null
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  ::v-deep .el-form-item {
    margin-right: 0;
  }
  .mr15 {
    margin-right: 15px;
  }
</style>
